import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LoadingButton from "@mui/lab/LoadingButton";
import { Box, Dialog, Typography, useMediaQuery } from "@mui/material";
import DialogContent from "@mui/material/DialogContent";
// import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import CustomDialogTitle from "components/customDialog/customDialogTitle";
import InvoiceSearchSkeleton from "components/skeletons/invoiceSearchSkeleton";
import { MOBILE_MEDIA_QUERY } from "constants/mediaQueries";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { styledDialogChildSX } from "styled/styledSXProperties/styledDialogueSX";
import { baseStyledPaperSX } from "styled/styledSXProperties/styledPaperSX";

import { closeInvoiceSummaryDialogue } from "../../../utils/invoiceUtils";
import FormatNameValue from "../../displays/formatNameValue";
import InvoiceSearchTable from "./invoiceSearchTable";
import InvoiceSearchCards from "./mobileSummaryCards/invoiceSearchCards";

const InvoiceSearch = () => {
    const isDesktop = useMediaQuery(MOBILE_MEDIA_QUERY);
    const INV_PER_PAGE = 6;
    const [pages, setPages] = useState(1);
    const invoices = useSelector((state) => state.invoiceSearch.invoiceList);
    const [pageLoading, setPageLoading] = useState(false);
    const totalResults = invoices.length;

    const displayInvoices = invoices.slice(0, pages * INV_PER_PAGE);

    const isOpen = useSelector(
        (state) => state.general.showInvoiceSummaryDialogue
    );
    const darkMode = useSelector((state) => state.general.darkMode);

    const isLoading = useSelector(
        (state) => state.invoiceSearch.invoiceIsLoading
    );

    const invoiceNumber = useSelector(
        (state) => state.invoiceSearch.invoiceNumber
    );

    const dispatch = useDispatch();

    const handleClose = (_event, reason) => {
        if (reason && reason == "backdropClick") return;
        closeInvoiceSummaryDialogue(dispatch);
        setPages(1);
    };

    const summaryDetails = [
        {
            header: "Invoice Number",
            content: invoiceNumber,
        },
        {
            header: "Total Results",
            content: totalResults,
        },
    ];

    const getNextPage = async () => {
        setPages(pages + 1);
        setPageLoading(false);
    };

    return (
        <>
            <Dialog
                fullScreen={!isDesktop}
                fullWidth
                maxWidth="lg"
                onClose={handleClose}
                open={isOpen}
                PaperProps={{
                    sx: baseStyledPaperSX(darkMode),
                }}
            >
                <CustomDialogTitle
                    onClose={handleClose}
                    title="Invoice Search Results:"
                    tooltip="Close Invoice Search"
                />
                <Grid container spacing={2} marginBottom="8px">
                    <Grid item xs={12} padding={"5px"} marginLeft={"25px"}>
                        <Box
                            sx={{
                                "&>*:not(:last-child):after": {
                                    content: "''",
                                    border: "1px solid",
                                    borderColor: "theme.primary",
                                    mx: "16px",
                                },
                            }}
                        >
                            {summaryDetails.map((detail) => (
                                <FormatNameValue
                                    key={detail.header}
                                    name={detail.header}
                                    value={detail.content}
                                    variant="body1"
                                    sx={{
                                        display: "inline-block",
                                        position: "right",
                                    }}
                                    error={detail.hasError}
                                />
                            ))}
                        </Box>
                    </Grid>
                    <Grid item xs={12} padding={"5px"} marginLeft={"25px"}>
                        <Typography variant={"body1"}>
                            Select from the results below to be taken to the
                            invoice summary page.
                        </Typography>
                    </Grid>
                </Grid>
                <DialogContent sx={styledDialogChildSX}>
                    {isLoading ? (
                        <InvoiceSearchSkeleton />
                    ) : isDesktop ? (
                        <InvoiceSearchTable
                            isPoSummary={false}
                            invoices={displayInvoices}
                            dispatch={dispatch}
                        />
                    ) : (
                        <InvoiceSearchCards
                            isPoSummary={false}
                            invoices={displayInvoices}
                            dispatch={dispatch}
                        />
                    )}
                </DialogContent>
                {/* If there are pages to scroll through, render see more button */}
                {pages < Math.ceil(totalResults / INV_PER_PAGE) && (
                    <Grid
                        item
                        xs={12}
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                    >
                        <LoadingButton
                            color="secondary"
                            endIcon={<ExpandMoreIcon />}
                            loading={pageLoading}
                            loadingPosition="end"
                            onClick={getNextPage}
                            sx={{
                                width: "20%",
                                mt: "6px",
                            }}
                        >
                            See More
                        </LoadingButton>
                    </Grid>
                )}
            </Dialog>
        </>
    );
};

export default InvoiceSearch;
